import ActionBtn from '@/components/ActionBtn'
import TechTextFields from './TechTextFields'
import TechFiles from './TechFiles'

const TechDataRow = ({ tech, formHandler, isLoading, removeTechnology, updateTechnology }) => {


  return (
    <div className="technology-item-card col-lg-4 mb-2">
      <div className="technology-item-card-content">

        <ActionBtn
          icon="carbon:close-filled"
          className="remove-tech-btn pointer"
          onApply={() => removeTechnology(tech.id || tech.attachmentId)} />

        <div className="row">
          <div className="col-12">
            <TechTextFields tech={tech} formHandler={formHandler} isLoading={isLoading} updateTechnology={updateTechnology} />
          </div>

          <div className="col-12">
            <TechFiles tech={tech} updateTechnology={updateTechnology} />
          </div>

        </div>
      </div>
    </div>
  )
}

export default TechDataRow